<!-- eslint-disable @angular-eslint/template/click-events-have-key-events -->
<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
@for (modal of modals; track modal) {
<div class="modal__backdrop" [@backdropAnimation] [style.zIndex]="modal.options.zIndex || 1000"
  (click)="onBackdropClick(modal, $event)">
  <div class="modal__container" [@modalAnimation] [ngClass]="[
           'modal__container--' + (modal.options.size || 'md'),
           modal.options.customClass || ''
         ]" (click)="$event.stopPropagation()">
    @if (resolveText(modal.options.title)) {
    <div class="modal__header">
      <h2 class="modal__title">{{ resolveText(modal.options.title) }}</h2>
      @if (modal.options.closable) {
      <button class="modal__close" (click)="closeModal(modal)">
        <i class="material-icons">close</i>
      </button>
      }
    </div>
    }
    <div class="modal__body" [ngClass]="{'modal__body--with-icon': shouldShowIcon(modal)}">
      @if (shouldShowIcon(modal)) {
      <div class="modal__icon" [ngClass]="getIconClass(modal.options.type)">
        <i class="material-icons">{{ getIconName(modal.options.type) }}</i>
      </div>
      }
      <div class="modal__content">
        @if (resolveText(modal.options.message)) {
        <p class="modal__message">{{ resolveText(modal.options.message) }}</p>
        }
        @if (modal.options.type === ModalType.FORM && forms.get(modal.id)) {
        <form [formGroup]="forms.get(modal.id)!" (ngSubmit)="submitForm(modal)">
          @for (field of modal.options.formFields; track field) {
          <div class="modal__form-field" [id]="'field_' + modal.id + '_container_' + field.name"
            [ngClass]="{'modal__field--hidden': !shouldFieldBeVisible(modal, field) || field.hidden}">
            <label [for]="'field_' + modal.id + '_' + field.name" class="modal__label">
              {{ resolveText(field.label) || field.name }}
              @if (field.required) {
              <span class="modal__required">*</span>
              }
            </label>
            @if (field.type === 'text') {
            <input [type]="'text'" [id]="'field_' + modal.id + '_' + field.name" [formControlName]="field.name"
              [placeholder]="resolveText(field.placeholder)"
              [attr.maxlength]="field.maxLength !== undefined ? field.maxLength : null" [ngClass]="[
                            'modal__input',
                            field.class || '',
                            getErrorMessage(modal, field.name) ? 'modal__input--error' : ''
                        ]">
            }
            @if (field.type === 'password') {
            <input type="password" [id]="'field_' + modal.id + '_' + field.name" [formControlName]="field.name"
              [placeholder]="resolveText(field.placeholder)" [attr.maxlength]="getAttributeValue(field.maxLength)" [ngClass]="[
    'modal__input',
    field.class || '',
    getErrorMessage(modal, field.name) ? 'modal__input--error' : ''
]">
            }
            @if (field.type === 'time') {
            <input type="time" [id]="'field_' + modal.id + '_' + field.name" [formControlName]="field.name"
              [placeholder]="resolveText(field.placeholder)" [ngClass]="[
    'modal__input',
    field.class || '',
    getErrorMessage(modal, field.name) ? 'modal__input--error' : ''
  ]">
            }
            @if (field.type === 'email') {
            <input type="email" [id]="'field_' + modal.id + '_' + field.name" [formControlName]="field.name"
              [placeholder]="resolveText(field.placeholder)" [attr.maxlength]="getAttributeValue(field.maxLength)" [ngClass]="[
        'modal__input',
        field.class || '',
        getErrorMessage(modal, field.name) ? 'modal__input--error' : ''
    ]">
            }
            @if (field.type === 'number') {
            <input type="text" [id]="'field_' + modal.id + '_' + field.name" [formControlName]="field.name"
              [placeholder]="resolveText(field.placeholder)" pattern="^-?\d+(\.\d+)?$" [attr.min]="field.min"
              [attr.max]="field.max" (keypress)="onNumberKeyPress($event, field)" [ngClass]="[
        'modal__input',
        field.class || '',
        getErrorMessage(modal, field.name) ? 'modal__input--error' : ''
    ]">
            }
            @if (field.type === 'textarea') {
            <textarea [id]="'field_' + modal.id + '_' + field.name" [formControlName]="field.name"
              [placeholder]="resolveText(field.placeholder)" [attr.maxlength]="getAttributeValue(field.maxLength)" [ngClass]="[
    'modal__textarea',
    field.class || '',
    getErrorMessage(modal, field.name) ? 'modal__textarea--error' : ''
]"></textarea>
            }
            @if (field.type === 'select') {
            <select [id]="'field_' + modal.id + '_' + field.name" [formControlName]="field.name" [ngClass]="[
                        'modal__select',
                        field.class || '',
                        getErrorMessage(modal, field.name) ? 'modal__select--error' : ''
                      ]">
              @if (resolveText(field.placeholder)) {
              <option value="" disabled selected>{{ resolveText(field.placeholder) }}
              </option>
              }
              @for (option of field.options; track option) {
              <option [value]="option.value">
                {{ option.label }}
              </option>
              }
            </select>
            }
            @if (field.type === 'multiselect') {
            <ng-select [id]="'field_' + modal.id + '_' + field.name" [formControlName]="field.name"
              [items]="field.options || []" [multiple]="true" [placeholder]="resolveText(field.placeholder)" bindLabel="label"
              bindValue="value" [closeOnSelect]="false" [clearable]="true" [searchable]="true" appendTo="body" [ngClass]="[
                              'modal__ng-select',
                              field.class || '',
                              getErrorMessage(modal, field.name) ? 'modal__ng-select--error' : ''
                            ]">
            </ng-select>
            }
            @if (field.type === 'checkboxlist') {
            <div class="modal__checkboxlist">
              @for (option of field.options; track option) {
              <div class="modal__checkboxlist-group">
                <div class="modal__checkboxlist-item">
                  <input type="checkbox"
                    [id]="'field_' + modal.id + '_' + field.name + '_' + option.value"
                    [checked]="isCheckboxListOptionSelected(modal, field.name, option.value)"
                    (change)="onCheckboxListChange(modal, field.name, option, $event)"
                    class="modal__checkboxlist-checkbox">
                  <label [for]="'field_' + modal.id + '_' + field.name + '_' + option.value"
                    class="modal__checkboxlist-label">
                    {{ option.label }}
                  </label>
                </div>
                @if (option.children && isCheckboxListOptionSelected(modal, field.name, option.value)) {
                <div class="modal__checkboxlist-children">
                  @for (child of option.children.options; track child) {
                  <div class="modal__checkboxlist-item">
                    <input type="checkbox"
                      [id]="'field_' + modal.id + '_' + option.children.fieldName + '_' + child.value"
                      [checked]="isCheckboxListOptionSelected(modal, option.children.fieldName, child.value)"
                      (change)="onCheckboxListChange(modal, option.children.fieldName, child, $event)"
                      class="modal__checkboxlist-checkbox">
                    <label [for]="'field_' + modal.id + '_' + option.children.fieldName + '_' + child.value"
                      class="modal__checkboxlist-label">
                      {{ child.label }}
                    </label>
                  </div>
                  }
                </div>
                }
              </div>
              }
            </div>
            }
            @if (field.type === 'checkbox') {
            <div class="modal__checkbox-container">
              <input [type]="'checkbox'" [id]="'field_' + modal.id + '_' + field.name" [formControlName]="field.name"
                class="modal__checkbox">
              <label [for]="'field_' + modal.id + '_' + field.name" class="modal__checkbox-label">
                {{ resolveText(field.placeholder) }}
              </label>
            </div>
            }
            @if (field.type === 'radio') {
            <div class="modal__radio-group">
              @for (option of field.options; track option; let i = $index) {
              <div class="modal__radio-container">
                <input [type]="'radio'" [id]="'field_' + modal.id + '_' + field.name + '_' + i"
                  [formControlName]="field.name" [value]="option.value" class="modal__radio">
                <label [for]="'field_' + modal.id + '_' + field.name + '_' + i" class="modal__radio-label">
                  {{ option.label }}
                </label>
              </div>
              }
            </div>
            }
            @if (field.type === 'date') {
            <input [type]="'date'" [id]="'field_' + modal.id + '_' + field.name" [formControlName]="field.name"
              [ngClass]="[
                       'modal__date',
                       field.class || '',
                       getErrorMessage(modal, field.name) ? 'modal__date--error' : ''
                     ]">
            }
            @if (getErrorMessage(modal, field.name)) {
            <div class="modal__error">
              {{ getErrorMessage(modal, field.name) }}
            </div>
            }
          </div>
          }
        </form>
        }
        @if (modal.options.type === ModalType.PASSWORD_CHANGE && forms.get(modal.id)) {
        <div class="modal__password-change">
          <form [formGroup]="forms.get(modal.id)!" (ngSubmit)="submitForm(modal)">
            @for (field of modal.options.formFields; track field) {
            <div class="modal__form-field">
              <label [for]="'field_' + modal.id + '_' + field.name" class="modal__label">
                {{ resolveText(field.label) }}
                @if (field.required) {
                <span class="modal__required">*</span>
                }
              </label>
              <div class="modal__password-field">
                <input [type]="isPasswordVisible(modal.id, field.name) ? 'text' : 'password'"
                  [id]="'field_' + modal.id + '_' + field.name" [formControlName]="field.name"
                  [placeholder]="resolveText(field.placeholder)" autocomplete="new-password" [ngClass]="[
            'modal__input',
            field.class || '',
            getErrorMessage(modal, field.name) ? 'modal__input--error' : ''
          ]">
                <button type="button" class="modal__password-toggle-btn"
                  (click)="togglePasswordVisibility(modal.id, field.name)"
                  [attr.aria-label]="isPasswordVisible(modal.id, field.name) ? 'Hide password' : 'Show password'">
                  <img
                    [src]="isPasswordVisible(modal.id, field.name) ? 'assets/icons/eye-open.svg' : 'assets/icons/eye-closed.svg'"
                    [alt]="isPasswordVisible(modal.id, field.name) ? 'Hide password' : 'Show password'"
                    class="black-filter">
                </button>
              </div>
              @if (field.name === 'newPassword' && modal.options.data?.showRequirements) {
              <div class="modal__password-requirements">
                <div class="modal__requirements-list">
                  @for (requirement of getPasswordCriteria(modal.options.data?.password || ''); track requirement) {
                  <div class="modal__requirement-item" [class.modal__requirement-met]="requirement.met"
                    [class.modal__requirement-unmet]="!requirement.met">
                    <div class="modal__requirement-icon">
                      @if (requirement.met) {
                      <span class="modal__check-icon">✓</span>
                      }
                      @if (!requirement.met) {
                      <span class="modal__cross-icon">✕</span>
                      }
                    </div>
                    <span class="modal__requirement-text">{{ requirement.text }}</span>
                  </div>
                  }
                </div>
              </div>
              }
              @if (getErrorMessage(modal, field.name)) {
              <div class="modal__error">
                {{ getErrorMessage(modal, field.name) }}
              </div>
              }
            </div>
            }
          </form>
        </div>
        }
        @if (modal.options.type === ModalType.CUSTOM) {
        <div class="modal__custom-component">
          @if (modal.options.data?.isImagePreview) {
          <div class="modal__image-preview">
            <div class="modal__image-container">
              <img [src]="modal.options.data.imageUrl" [alt]="resolveText(modal.options.title) || 'Image preview'"
                class="modal__image-preview-img">
            </div>
            @if (modal.options.data?.showDownload) {
            <div class="modal__image-actions">
              <button class="modal__download-btn"
                (click)="downloadImage(modal.options.data.imageUrl, modal.options.data.downloadFilename)">
                <i class="material-icons">download</i>
                Download Image
              </button>
            </div>
            }
          </div>
          } @else if (modal.options.component) {
          <ng-container *ngComponentOutlet="modal.options.component; inputs: modal.options.data"></ng-container>
          }
        </div>
        }
        @if (modal.options.type === ModalType.PICTURE_UPLOAD) {
        <div class="modal__picture-upload">
          @if (!modal.options.data?.imageUrl) {
          <div class="modal__picture-input-wrapper">
            <div class="modal__picture-dropzone"
              [class.modal__picture-dropzone--active]="dragOverModalId === modal.id"
              (dragover)="onDropzoneDragOver($event)"
              (dragenter)="onDropzoneDragEnter($event, modal.id)"
              (dragleave)="onDropzoneDragLeave($event, modal.id)"
              (drop)="onDropFile($event, modal)">
              <input type="file" id="picture-upload-{{modal.id}}" [accept]="modal.options.data?.fileTypes || 'image/*'"
                (change)="onImageFileSelected($event, modal)" class="modal__picture-input">
              <label for="picture-upload-{{modal.id}}" class="modal__picture-input-label">
                <i class="material-icons">cloud_upload</i>
                <span>Drag & drop or click to upload</span>
                <small>Max size: {{(modal.options.data?.maxFileSize || 5242880) /
                  1048576}}MB</small>
              </label>
            </div>
          </div>
          }
          @if (modal.options.data?.imageUrl) {
          <div class="modal__picture-editor">
            <div class="modal__picture-toolbar">
              @if (modal.options.data?.cropControls) {
              <div class="modal__picture-aspect-ratio">
                <button class="modal__picture-tool-button"
                  [class.modal__picture-tool-button--active]="modal.options.data?.cropRatio === 'free'"
                  (click)="setCropRatio('free', modal)" title="Free aspect ratio">
                  <i class="material-icons">crop_free</i>
                </button>
                <button class="modal__picture-tool-button"
                  [class.modal__picture-tool-button--active]="modal.options.data?.cropRatio === 'square'"
                  (click)="setCropRatio('square', modal)" title="Square (1:1)">
                  <i class="material-icons">crop_square</i>
                </button>
                <button class="modal__picture-tool-button"
                  [class.modal__picture-tool-button--active]="modal.options.data?.cropRatio === '4:3'"
                  (click)="setCropRatio('4:3', modal)" title="4:3 aspect ratio">
                  <span>4:3</span>
                </button>
                <button class="modal__picture-tool-button"
                  [class.modal__picture-tool-button--active]="modal.options.data?.cropRatio === '16:9'"
                  (click)="setCropRatio('16:9', modal)" title="16:9 aspect ratio">
                  <span>16:9</span>
                </button>
              </div>
              }
              @if (modal.options.data?.rotateControls) {
              <div class="modal__picture-rotate">
                <button class="modal__picture-tool-button" (click)="rotateImage(modal, -90)" title="Rotate left">
                  <i class="material-icons">rotate_left</i>
                </button>
                <button class="modal__picture-tool-button" (click)="rotateImage(modal, 90)" title="Rotate right">
                  <i class="material-icons">rotate_right</i>
                </button>
              </div>
              }
              @if (modal.options.data?.zoomControls) {
              <div class="modal__picture-zoom">
                <button class="modal__picture-tool-button" (click)="adjustZoom(modal, 0.9)" title="Zoom out">
                  <i class="material-icons">zoom_out</i>
                </button>
                <button class="modal__picture-tool-button" (click)="adjustZoom(modal, 1.1)" title="Zoom in">
                  <i class="material-icons">zoom_in</i>
                </button>
              </div>
              }
              @if (modal.options.data?.resetButton) {
              <div class="modal__picture-reset">
                <button class="modal__picture-tool-button modal__picture-tool-button--reset" (click)="resetCrop(modal)"
                  title="Reset all changes">
                  <i class="material-icons">refresh</i>
                  <span>Reset</span>
                </button>
              </div>
              }
            </div>
            <div class="modal__picture-canvas-container">
              <canvas #imageCanvas class="modal__picture-canvas"></canvas>
              <div class="modal__picture-instructions">
                <p>Drag to move, handles to resize</p>
              </div>
            </div>
          </div>
          }
        </div>
        }
        @if (modal.options.type === ModalType.CREATE_VERSION || modal.options.type === ModalType.EDIT_VERSION) {
        <div class="modal__version-file">
          @if (isEnteringNewVersion(modal)) {
          <div
            class="modal__version-dropzone"
            [class.modal__version-dropzone--active]="modal.options.data?.fileDropActive"
            (dragover)="onVersionFileDragOver($event)"
            (dragenter)="onVersionFileDragEnter($event, modal)"
            (dragleave)="onVersionFileDragLeave($event, modal)"
            (drop)="onVersionFileDrop($event, modal)">
            <label [for]="'versionFileInput_' + modal.id" class="modal__version-dropzone-label"
              [class.modal__version-dropzone-label--active]="modal.options.data?.fileDropActive">
              @if (modal.options.data?.selectedFile && (!modal.options.data?.isEditMode || modal.options.data?.selectedFile !== modal.options.data?.originalSelectedFile)) {
              <span>{{ modal.options.data.selectedFile.name }}</span>
              } @else if (!modal.options.data?.isEditMode && modal.options.data?.currentFileName) {
              <span>{{ modal.options.data.currentFileName }}</span>
              @if (modal.options.data?.isPreloadingFile) {
              <small class="modal__version-dropzone-loading">{{ modal.options.data?.messages?.loadingFile || 'Loading file…' }}</small>
              }
              } @else {
              <span>{{ modal.options.data?.messages?.clickOrDrop || 'Click or drag & drop' }}</span>
              }
            </label>
            <input type="file" [id]="'versionFileInput_' + modal.id" (change)="onVersionFileSelected($event, modal)"
              [attr.accept]="modal.options.data?.acceptFileTypes || '.pdf,.mp4'" hidden />
          </div>
          }

          @if (modal.options.data?.isEditMode) {
          <p class="modal__version-hint">
            {{
              modal.options.data?.messages?.newVersionHint ||
                'To add a new version: write a new version name and attach its file. Pick an existing version to edit it.'
            }}
          </p>
          }

          <div class="option__content">
            <label [for]="'versionCustomName_' + modal.id" class="form__label">
              {{ modal.options.data?.messages?.fileName || 'File name' }}
            </label>
            <input [id]="'versionCustomName_' + modal.id" class="form__input"
              [placeholder]="modal.options.data?.messages?.fileNamePlaceholder || 'Enter file name'"
              [ngModel]="modal.options.data?.customFileName"
              (ngModelChange)="onVersionFieldChange(modal, 'customFileName', $event)" />
          </div>

          <div class="popup-options__grid">
            <!-- Control de versión -->
            <div class="popup-options__item">
              <label class="checkbox__label">
                <input type="checkbox" [ngModel]="modal.options.data?.showList"
                  (ngModelChange)="onVersionShowListChange(modal, $event)" class="file-checkbox"
                  [disabled]="modal.options.data?.isEditMode && modal.options.data?.versionContentLocked" />
                <span class="checkbox__text">{{ modal.options.data?.messages?.addNewVersion || 'Add version control' }}</span>
              </label>
              <div class="option__horizontal">
                <div class="option__content">
                  @if (!modal.options.data?.showList) {
                  <div class="select-overlay" (click)="enableVersionAndFocus(modal)"></div>
                  }
                  <label class="form__label">{{ modal.options.data?.messages?.selectFileVersion || 'File version:' }}</label>
                  <ng-select #versionSelectRef class="custom-ng-select-version"
                    [items]="modal.options.data?.availableVersions || []"
                    [ngModel]="modal.options.data?.selectedVersionItem"
                    (ngModelChange)="onVersionFieldChange(modal, 'selectedVersionItem', $event)" [clearable]="true"
                    [searchable]="true" [editableSearchTerm]="true" [addTag]="addVersionTag"
                    [placeholder]="modal.options.data?.messages?.selectFileVersion || 'ED2 Rev01'"
                    [disabled]="!modal.options.data?.showList" (search)="onVersionSearch(modal, $event.term)"
                    (change)="onVersionChange(modal)" (blur)="onCommitTypedVersion(modal)"></ng-select>
                </div>
                <div class="option__content">
                  @if (!modal.options.data?.showList) {
                  <div class="select-overlay" (click)="enableVersionAndFocus(modal)"></div>
                  }
                  <label class="form__label">{{ modal.options.data?.messages?.date || 'Date' }}</label>
                  <input type="text" class="form__input" [class.input--error]="modal.options.data?.versionDateError"
                    [ngModel]="modal.options.data?.versionDate" placeholder="MM/YYYY" maxlength="7" autocomplete="off"
                    [disabled]="!modal.options.data?.showList" (focus)="onVersionDateFocus(modal)"
                    (input)="onVersionDateInput($event, modal)" />
                </div>
              </div>
            </div>
            <!-- Caducidad -->
            <div class="popup-options__item">
              <label class="checkbox__label">
                <input type="checkbox" [ngModel]="modal.options.data?.showExpiration"
                  (ngModelChange)="onVersionShowExpirationChange(modal, $event)" class="file-checkbox"
                  [disabled]="modal.options.data?.expirationContentLocked" />
                <span class="checkbox__text">{{ modal.options.data?.messages?.expirationDate || 'Expiration Date' }}</span>
              </label>
              <div class="option__content">
                @if (!modal.options.data?.showExpiration) {
                <div class="select-overlay" (click)="enableExpirationAndFocus(modal)"></div>
                }
                <label class="form__label">{{ modal.options.data?.messages?.date || 'Date' }}</label>
                <input #expirationInput type="date" class="form__input" [ngModel]="modal.options.data?.expirationDate"
                  (ngModelChange)="onVersionFieldChange(modal, 'expirationDate', $event)"
                  [min]="modal.options.data?.todayDateString" [disabled]="!modal.options.data?.showExpiration" />
              </div>
            </div>
            <!-- Acuse de recibo -->
            <div class="popup-options__item">
              <label class="checkbox__label">
                <input type="checkbox" [ngModel]="modal.options.data?.showAcknowledgment"
                  (ngModelChange)="onVersionShowAcknowledgmentChange(modal, $event)" class="file-checkbox"
                  [disabled]="modal.options.data?.isEditMode && modal.options.data?.acknowledgmentContentLocked" />
                <span class="checkbox__text">
                  {{ modal.options.data?.messages?.acknowledgmentReceipt || 'Acknowledgment of receipt' }}
                </span>
              </label>
              <div class="option__content">
                <label class="form__label">{{ modal.options.data?.messages?.user || 'User' }}</label>
                @if (!modal.options.data?.showAcknowledgment) {
                <div class="select-overlay" (click)="onVersionShowAcknowledgmentChange(modal, true)"></div>
                }
                <ng-select class="custom-ng-select-multi" [items]="modal.options.data?.acknowledgmentOptions || []"
                  [ngModel]="modal.options.data?.acknowledgmentSelectedUsers"
                  (ngModelChange)="onVersionFieldChange(modal, 'acknowledgmentSelectedUsers', $event)" bindLabel="user"
                  [loading]="modal.options.data?.isLoadingAcknowledgmentOptions" [multiple]="true" [clearable]="true"
                  [disabled]="!modal.options.data?.showAcknowledgment"
                  [placeholder]="modal.options.data?.messages?.selectUser || 'Select a user'"
                  (search)="onVersionAcknowledgmentSearch(modal, $event.term)">
                  <ng-template ng-option-tmp let-item="item">
                    <span>{{ item.user }}</span>
                  </ng-template>
                </ng-select>
              </div>
            </div>
            <!-- Firma -->
            <div class="popup-options__item">
              <label class="checkbox__label">
                <input type="checkbox" [ngModel]="modal.options.data?.showSignature"
                  (ngModelChange)="onVersionShowSignatureChange(modal, $event)" class="file-checkbox"
                  [disabled]="
                    !isVersionFileSelectedPdf(modal) ||
                    (modal.options.data?.isEditMode && modal.options.data?.signatureContentLocked)
                  " />
                <span class="checkbox__text">
                  {{ modal.options.data?.messages?.requiresSignature || 'This file requires signature' }}
                </span>
              </label>
              <div class="option__content">
                <label class="form__label">{{ modal.options.data?.messages?.user || 'User' }}</label>
                @if (!modal.options.data?.showSignature) {
                <div class="select-overlay" (click)="enableVersionSignatureIfAllowed(modal)"></div>
                }
                <ng-select class="custom-ng-select-multi" [items]="modal.options.data?.signatureOptions || []"
                  [ngModel]="modal.options.data?.signatureSelectedUsers"
                  (ngModelChange)="onVersionFieldChange(modal, 'signatureSelectedUsers', $event)" bindLabel="user"
                  [loading]="modal.options.data?.isLoadingSignatureOptions" [multiple]="true" [clearable]="true"
                  [disabled]="!modal.options.data?.showSignature"
                  [placeholder]="modal.options.data?.messages?.selectUser || 'Select a user'"
                  (search)="onVersionSignatureSearch(modal, $event.term)">
                  <ng-template ng-option-tmp let-item="item">
                    <span>{{ item.user }}</span>
                  </ng-template>
                </ng-select>
              </div>
            </div>
            <!-- Notas -->
            <div class="popup-options__item popup-options__full-width">
              <div class="option__content">
                <label class="form__label">{{ modal.options.data?.messages?.enterNotes || 'Enter notes' }}</label>
                <textarea rows="3" [placeholder]="modal.options.data?.messages?.enterNotes || 'Enter notes'"
                  class="form__textarea" [ngModel]="modal.options.data?.fileNotes"
                  (ngModelChange)="onVersionFieldChange(modal, 'fileNotes', $event)"></textarea>
              </div>
            </div>
          </div>

          @if (modal.options.data?.errorMessage) {
          <div class="modal__version-error">
            <span>{{ translateData?.error || 'Error' }}: {{ modal.options.data.errorMessage }}</span>
          </div>
          }
        </div>
        }
        @if (modal.options.type === ModalType.TABLE) {
        <div class="modal__table-container">
          <app-table [columns]="modal.options.data?.columns || []" [rows]="modal.options.data?.rows || []">
          </app-table>
        </div>
        }
        @if (modal.options.type === ModalType.SHARE) {
        <div class="modal__share">
          <div class="modal__share-buttons">
            <ul class="icons">
              <a href="#"><i class="fab fa-facebook-f"></i></a>
              <a href="#"><i class="fab fa-twitter"></i></a>
              <a href="#"><i class="fab fa-instagram"></i></a>
              <a href="#"><i class="fab fa-whatsapp"></i></a>
              <a href="#"><i class="fab fa-telegram-plane"></i></a>
            </ul>
          </div>
          <div class="modal__share-copy-lnk">
            <p>Or copy link</p>
            <button class="modal__share-btn" (click)="copyLink(modal.options.data?.link)">
              <i class="material-icons">content_copy</i>
              Copy link
            </button>
          </div>
        </div>
        }
      </div>
    </div>
    @if (modal.options.buttons && modal.options.buttons.length > 0) {
    <div class="modal__footer">
      @for (button of modal.options.buttons; track button) {
      <button [ngClass]="[
                  'modal__button',
                  button.primary ? 'modal__button--primary' : 'modal__button--secondary',
                  button.class || ''
                ]" [disabled]="isModalButtonDisabled(modal, button)" (click)="onButtonClick(modal, button)">
        {{ resolveText(button.text) }}
      </button>
      }
    </div>
    }
  </div>
</div>
}